import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

/**
 * Fires a GA4 page_view on mount and on every route change.
 * Renders nothing; must live inside the client-side BrowserRouter
 * (never in the SSR tree — useEffect keeps it inert there anyway).
 */
export function AnalyticsTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    trackPageView(pathname + search);
  }, [pathname, search]);

  return null;
}
